<div class="row">
  <div class="col-sm-8 col-sm-offset-2">
    <h2>Save a new book</h2>
    <br>
    <form [formGroup]="bookForm" (ngSubmit)="onSaveBook()">
      <div class="form-group">
        <label for="title">Title</label>
        <input type="text" class="form-control" id="title" formControlName="title">
      </div>
      <div class="form-group">
        <label for="author">Author</label>
        <input type="text" class="form-control" id="author" formControlName="author">
      </div>
      <div class="form-group">
        <label>Add a picture</label>
        <!-- L'évènement change arrive quand l'utilisateur a cliqué sur ce bouton et a sélectionné un fichier. En gros, ça a inséré un chemin dans un champ à la base vide. -->
        <!-- accept est pour choisir qu'on accepte que des fichiers image -->
        <input type="file" (change)="detectFiles($event)" class="form-control" accept="image/*">
        <!-- Ajout texte de chargement -->
        <p *ngIf="fileIsUploading">Uploading...</p>
        <p class="text-success" *ngIf="fileUploaded && !fileIsUploading">File uploaded!</p>
      </div>
      <!-- On ajoute à [disabled] le fait qu'un fichier image soit en train de charger, pour éviter des bugs-->
      <br>
      <div>
        <button class="btn btn-success" [disabled]="bookForm.invalid || fileIsUploading" type="submit">Save
        </button>
        <button class="btn btn-default pull-right" (click)="onBack()">Cancel</button>
      </div>
    </form>
  </div>
</div>